import { useEffect, useState } from "react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

const SESSION_STORAGE_KEY = "fp_device_id";
const CONFIDENCE_SCORE_KEY = "fp_confidence_score";

export function useDeviceId(): { deviceId: string | undefined; confidenceScore: number | undefined } {
  const [deviceId, setDeviceId] = useState<string | undefined>(() => {
    try {
      return sessionStorage.getItem(SESSION_STORAGE_KEY) ?? undefined;
    } catch {
      return undefined;
    }
  });
  const [confidenceScore, setConfidenceScore] = useState<number | undefined>(() => {
    try {
      const score = sessionStorage.getItem(CONFIDENCE_SCORE_KEY);
      return score ? Number(score) : undefined;
    } catch {
      return undefined;
    }
  });

  useEffect(() => {
    if (deviceId) return;

    let cancelled = false;

    (async () => {
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();

        if (!cancelled) {
          setDeviceId(result.visitorId);
          setConfidenceScore(result.confidence.score);
          try {
            sessionStorage.setItem(SESSION_STORAGE_KEY, result.visitorId);
            sessionStorage.setItem(CONFIDENCE_SCORE_KEY, result.confidence.score.toString());
          } catch {
            // sessionStorage may be unavailable
          }
        }
      } catch {
        // Graceful degradation: FingerprintJS blocked or unavailable
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [deviceId, confidenceScore]);

  return { deviceId, confidenceScore };
}
